import React from 'react'
import { useForm } from 'react-hook-form'
import {
  Container, TextField, Grid, Button, Typography, RadioGroup, FormControlLabel, Radio, Paper,
  Select, Avatar,
} from '@material-ui/core'
import HomeIcon from '@material-ui/icons/Home'
import { Alert } from '@material-ui/lab'
import { Link, useHistory } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { yupResolver } from '@hookform/resolvers/yup'
// import { signupSchema } from '../../../utils/User/validation'
import style from './index.module.css'
import { districts } from '../../../utils/User/mp.district.json'
import { time } from '../../../utils/User/availTime.json'
import { orderRequest } from '../../../redux-saga/User/Order/Reducer'
// import Util from '../../../utils/User/Util'

const Order = () => {
  const dispatch = useDispatch()
  const { register, handleSubmit, errors } = useForm()
  const history = useHistory()
  const error = useSelector((state) => state.signup.error)
  const { user } = useSelector((state) => state.login)
  // Util.geoPermission()
  const onSubmit = (data) => {
    const {
      contact, name, address, pinCode, availTime, district,
    } = data
    const pesticideList = JSON.parse(localStorage.getItem('orderList'))
    if (pesticideList?.length) {
      pesticideList.forEach((pesticide) => {
        const {
          id: pesticideId, price, quantity, sellerId,
        } = pesticide
        dispatch(orderRequest({
          pesticideId,
          itemType: null,
          price,
          paidAmount: 0,
          contact,
          name,
          address,
          pinCode,
          availTime,
          district,
          status: 'placed',
          quantity,
          itemCount: 1,
          review: '',
          date: new Date().toLocaleDateString(),
          time: new Date().toLocaleTimeString(),
          rating: null,
          sellerId,
          userId: user?.id,
        }))
      })
    }
  }
  return (
    <Container className={ style.back }>
      <Grid container direction='column' justify='center' alignItems='center'>
        <Grid item className={ style.space }>
          <Typography variant='h4'>Delivery details</Typography>
        </Grid>
        <Grid container spacing={ 2 } justify='center' alignItems='center'>
          <Grid item spacing={ 2 } className={ style.space }>
            <Avatar spacing={ 2 } className={ style.space } item variant='contained' color='primary'>
              <HomeIcon />
            </Avatar>
          </Grid>
        </Grid>
        <form onSubmit={ handleSubmit(onSubmit) }>
          <Grid container spacing={ 2 }>
            <Grid item className={ style.space } xs={ 12 } sm={ 6 }>
              <TextField
                variant='outlined'
                label='Contact (Required)'
                fullWidth
                inputRef={ register }
                name='contact'
                defaultValue={ user?.contact }
              />
              <p className={ style.error }>{errors.contact?.message}</p>
            </Grid>
            <Grid item className={ style.space } xs={ 12 } sm={ 6 }>
              <TextField
                required
                variant='outlined'
                label='Name (Required)'
                fullWidth
                inputRef={ register }
                name='name'
                defaultValue={ user?.username }
              />
              <p className={ style.error }>{errors.name?.message}</p>
            </Grid>
          </Grid>
          <Grid container spacing={ 2 }>
            <Grid className={ style.space } xs={ 12 } sm={ 12 }>
              <TextField
                required
                variant='outlined'
                label='Address'
                fullWidth
                name='address'
                inputRef={ register }
                defaultValue={ user?.address }
              />
              <p className={ style.error }>{errors.address?.message}</p>
            </Grid>
          </Grid>
          <Grid container spacing={ 2 }>
            <Grid item className={ style.space } xs={ 12 } sm={ 6 }>
              <TextField
                required
                variant='outlined'
                label='Pin Code'
                fullWidth
                name='pinCode'
                inputRef={ register }
                defaultValue={ user?.pinCode }
              />
              <p className={ style.error }>{errors.pinCode?.message}</p>
            </Grid>
            <Grid item className={ style.space } xs={ 12 } sm={ 6 }>
              <Select
                required
                native
                variant='outlined'
                fullWidth
                inputRef={ register }
                name='availTime'
              >
                <option label='Delivery Time' />
                {
                    time.map((tz) => (
                      <option key={ tz } value={ tz }>{ tz }</option>
                    ))
                  }
              </Select>
              <p className={ style.error }>{errors.availTime?.message}</p>
            </Grid>
          </Grid>
          <Grid container spacing={ 2 }>
            <Grid item className={ style.space } xs={ 12 }>
              <Select
                required
                native
                variant='outlined'
                fullWidth
                inputRef={ register }
                name='district'
                defaultValue={ user?.district }
              >
                <option label='Select District' />
                {
                    districts.map((district) => (
                      <option key={ district } value={ district }>{ district }</option>
                    ))
                  }
              </Select>
              <p className={ style.error }>{errors.district?.message}</p>
            </Grid>
          </Grid>
          <Grid container spacing={ 2 } justify='center' alignItems='center'>
            {
                  error
                    ? (
                      <Alert severity='error'>
                        { error }
                      </Alert>
                    )
                    : <></>
                }

            <Grid container spacing={ 2 } className={ style.bottom } justify='center' alignItems='center'>
              <Grid item>
                <Button
                  variant='contained'
                  color='secondary'
                  type='submit'
                >
                  Place Order
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </form>
      </Grid>
    </Container>
  )
}
export default Order
